import React, { lazy } from 'react';

// project import
import UserGuard from 'utils/route-guard/UserGuard';
import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';

// render - login
const AuthLogin = Loadable(lazy(() => import('pages/auth/login')));
const AuthForgotPassword = Loadable(lazy(() => import('pages/auth/forgot-password')));
const AuthCheckMail = Loadable(lazy(() => import('pages/auth/check-mail')));
const NonAuthResetPassword = Loadable(
    lazy(() => import('pages/auth/NonAuthResetPassword'))
);
const AuthCodeVerification = Loadable(lazy(() => import('pages/auth/code-verification')));
const RegisterUser = Loadable(lazy(() => import('pages/auth/register-user')));
const LogoutPrompt = Loadable(lazy(() => import('pages/auth/logout')));
const AddRegistration = Loadable(lazy(() => import('pages/main-pages/AddRegistration')));
const RemovalRequest = Loadable(lazy(() => import('pages/main-pages/RemovalRequest')));

// ==============================|| AUTH ROUTING ||============================== //

const AuthRoutes = {
    path: '/',
    children: [
        {
            path: '/',
            element: (
                <UserGuard>
                    <CommonLayout />
                </UserGuard>
            ),
            children: [
                {
                    path: '/',
                    element: <AuthLogin />
                },
                {
                    path: 'login',
                    element: <AuthLogin />
                },
                {
                    path: 'code',
                    element: <AuthLogin />
                },
                {
                    path: 'new-password',
                    element: <AuthLogin />
                },
                // {
                //   path: 'register',
                //   element: <AuthRegister />
                // },
                {
                    path: 'forgot-password',
                    element: <AuthForgotPassword />
                },
                {
                    path: 'check-mail',
                    element: <AuthCheckMail />
                },
                {
                    path: 'auth-service',
                    element: <NonAuthResetPassword />
                },
                {
                    path: 'logout',
                    element: <LogoutPrompt />
                },
                {
                    path: 'code-verification',
                    element: <AuthCodeVerification />
                },
                {
                    path: 'register-user',
                    element: <RegisterUser />
                },
                {
                    path: 'register/:shortCode',
                    element: <AddRegistration />
                },
                {
                    path: 'request-account-removal',
                    element: <RemovalRequest />
                }
            ]
        }
    ]
};

export default AuthRoutes;
